import { h } from 'preact';

const CheckSimple = (props: any) => (
	<svg
		width={29}
		height={26}
		viewBox="0 0 29 26"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M.143 13.276l10.815 11.82L28.832 3.238 24.558 0 10.666 16.45 3.9 9.617l-3.756 3.66z"
			fill="#fff"
		/>
	</svg>
);

export default CheckSimple;
